import { useTheme } from "@emotion/react";
import { Divider, List, Stack, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import { Fragment, useState } from "react";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import { camelCaseToSentance } from "../../../utils/camelCaseToSentence";
import { PROJECT_STATS } from "./constants";

const StatBlock = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const [viewPortEntered, setViewPortEntered] = useState(false);
  const [onCountUpEnd, setOnCountUpEnd] = useState(false);
  return (
    <Box
      py={10}
      pl={{ xs: 0, md: 1, lg: 6 }}
      pr={{ xs: 0, md: 4, lg: 15 }}
      pb={{ xs: 8, md: 10 }}
      boxSizing="border-box"
      borderRadius={6}
      m="auto"
    >
      <VisibilitySensor
        active={!viewPortEntered}
        onChange={(isVisible) => {
          if (isVisible) {
            setViewPortEntered(true);
          }
        }}
        delayedCall
      >
        <Stack
          // justifyContent="space-between"
          justifyContent="space-between"
          width={{ xs: "100%", md: "80%" }}
          m="auto"
          alignItems="center"
          direction={{ md: "row", xs: "column" }}
        >
          {Object.entries(PROJECT_STATS).map(
            ([key, { value, suffix, decimal }], idx) => (
              <Fragment key={idx}>
                <Stack
                  spacing={{ xs: 1, md: 4 }}
                  direction={{ xs: "column", lg: "row" }}
                  textAlign={{ xs: "center", lg: "left" }}
                  maxWidth={240}
                  flex={1}
                  alignItems="center"
                >
                  <CountUp
                    start={viewPortEntered ? null : 0}
                    end={value}
                    duration={1}
                    onEnd={() => (viewPortEntered ? setOnCountUpEnd(true) : "")}
                    decimals={decimal}
                  >
                    {({ countUpRef }) => {
                      return (
                        <>
                          <Typography
                            ref={countUpRef}
                            variant="h2"
                            typography={{ xs: "h3", sm: "h2" }}
                            style={{ fontWeight: 500 }}
                            textTransform="capitalize"
                          >
                            {onCountUpEnd && (
                              <Box display="inline">{suffix}</Box>
                            )}
                          </Typography>
                        </>
                      );
                    }}
                  </CountUp>
                  <Typography
                    variant="body1"
                    textTransform="capitalize"
                    color="grey.500"
                    width={{ xs: "100%", md: "80%" }}
                  >
                    {camelCaseToSentance(key)}
                  </Typography>
                </Stack>
                {idx < Object.entries(PROJECT_STATS).length - 1 &&
                  (md ? (
                    <List>
                      <Divider
                        sx={{ borderColor: "#ffffff50", height: "48px" }}
                        orientation="vertical"
                      />
                    </List>
                  ) : (
                    <List sx={{ width: "80%", my: 4, mx: "auto" }}>
                      <Divider
                        sx={{ borderColor: "#ffffff50" }}
                        orientation="horizontal"
                      />
                    </List>
                  ))}
              </Fragment>
            )
          )}
        </Stack>
      </VisibilitySensor>
    </Box>
  );
};

export default StatBlock;
